// Libellé d'un devis déposé sur une demande auto (PER-2500) : nommé par sa
// compagnie quand graal la porte (« Devis AssurAli », « Devis Allianz (Prima) »,
// `nomCompagnie` du document, PER-2498), sinon le libellé de repli donné par
// l'écran (type du document dans le panneau, nom du fichier sur la carte).
// Aucun import React : testable avec jest tel quel.

const nettoye = (valeur) => (typeof valeur === "string" ? valeur.trim() : "");

/** « Devis <compagnie> » si le document porte sa compagnie, sinon `repli`. */
export const libelleDevis = (document, repli = "Devis auto Perceval") => {
  const compagnie = nettoye(document?.nomCompagnie) || nettoye(document?.nom_compagnie);
  return compagnie ? `Devis ${compagnie}` : repli;
};

/** Nom de la compagnie d'un document, ou null : pour l'infobulle « Généré par l'IA ». */
export const compagnieDuDocument = (document) =>
  nettoye(document?.nomCompagnie) || nettoye(document?.nom_compagnie) || null;
